import React from "react";
import PolicyPage from "../PrivacyPolicy/PolicyPage";
import BreadCrumb from "../BreadCrumb/BreadCrumb";

const FooterPrivacy = () => {
  return (
    <div>
      <div>
        <BreadCrumb
          paths={[
            { name: "Home", path: "/dashboard" },
            { name: "Privacy-Policy", path: "" },
          ]}
        />
      </div>
      <div style={{margin:"20px 0px" }}>
        <PolicyPage />
      </div>
    </div>
  );
};

export default FooterPrivacy;
